import { Theme } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';

export const useStyles = makeStyles((theme: Theme) => ({
  cardTop: {
    padding: theme.spacing(2),
    flexDirection: 'row',
    display: 'flex',
    justifyContent: 'space-between'
  },
  cardContent: {
    padding: `0px ${theme.spacing(2)}`,
    flexGrow: 1
  },
  cardBottom: {
    padding: `${theme.spacing(1)} ${theme.spacing(2)}`,
    flexDirection: 'row',
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center'
  },
  card: {
    width: '212px',
    minHeight: '212px',
    margin: theme.spacing(1),
    display: 'flex',
    flexDirection: 'column'
  }
}));
